import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import LoadingCircle from '~components/Loading';
import CompanySectionTitle from '~features/company/CompanySectionTitle';
import useGetWikiSalaryChart from '~hooks/query/company/useCompanyWikiChart';
import { COMPANYS_SOURCE_VALUE, IWikiChart } from '~types/company';
import { generateUUID } from '~utils/common/uuid';

import { S } from '../style';
import ChartContents from './GraphContents';

interface WikiSalary {
  id: string;
  isSalaryBlocked: boolean;
  selectSource: COMPANYS_SOURCE_VALUE;
}
function WikiSalary({ id, isSalaryBlocked, selectSource }: WikiSalary) {
  const wrapperRef = useRef<HTMLUListElement>(null);
  const router = useRouter();
  const query = useGetWikiSalaryChart(id, isSalaryBlocked, selectSource);

  useEffect(() => {
    const [path, hash] = router.asPath.split('#');

    if (query.isSuccess && wrapperRef.current && hash === 'wiki-salary') {
      if (window) {
        router.replace(path);
        wrapperRef.current.scrollIntoView();
      }
    }
  }, [query.isSuccess]);

  if (query.isLoading || query.isError || query.isIdle) {
    return (
      <S.SalaryGrpahWrapper>
        <LoadingCircle />
      </S.SalaryGrpahWrapper>
    );
  }

  return (
    <S.SalaryGrpahWrapper ref={wrapperRef} key={generateUUID()}>
      {query.transformedWitkSalary.map((graphData: IWikiChart, index: number) => (
        <S.SalaryGraph key={index}>
          <CompanySectionTitle>
            {index === 0 ? '신입 예상 연봉' : '경력 예상 연봉'}
          </CompanySectionTitle>

          <ChartContents
            companyId={id}
            data={query.data}
            selectSource={selectSource}
            graphData={graphData}
            careerType={index === 0 ? 'rookie' : 'career'}
          />
        </S.SalaryGraph>
      ))}
    </S.SalaryGrpahWrapper>
  );
}

export default WikiSalary;
